<template>
  <div>
    <v-card>
      <v-card-title>
        <div>
          <h3 class="headline mb-0">{{labels.premium}}</h3>
        </div>
        <v-spacer></v-spacer>
        <div v-if="checkAccess(['motorQuoteBen'])">
          <!-- <v-menu offset-y v-if="addBenefitList.length > 0" :max-height="300">
          <v-btn slot="activator">
            <span>Add Benefit</span>
            <v-icon right>mdi-playlist-plus</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile v-for="benefit in addBenefitList" :key="benefit.value" @click="addBenefit(benefit.value)">
              <v-list-tile-title>{{ benefit.label }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu> -->
          <v-autocomplete v-model="addBenefit" v-if="addBenefitList.length > 0" :items="addBenefitList" label="Add Benefit" item-text="label" item-value="value" prepend-icon="mdi-playlist-plus" outline @change="doAddBenefit" clearable></v-autocomplete>
        </div>
      </v-card-title>
      <table class="v-datatable v-table theme--light" v-if="premiumInfo.init === 1">
        <thead>
          <tr>
            <th class="text-xs-left">Benefit</th>
            <th class="text-xs-left">Description</th>
            <th class="text-xs-right" width="200px">Amount</th>
            <th class="text-xs-right" width="70px"></th>
          </tr>
        </thead>
        <tbody>
          <template v-if="checkAccess(['motorQuoteShowBen'])">
            <tr v-for="benefit in premiumInfo.benefits" :key="benefit.value" class="benefitRow">
              <td>{{benefit.value}}</td>
              <td>{{benefit.desc}}</td>
              <td class="text-xs-right">{{currPrefix}}{{formatDisplayNumber(benefit.amt)}}</td>
              <td class="text-xs-right">
                <v-btn v-if="isAddableBenefit(benefit.value) && checkAccess(['motorQuoteBen'])" flat icon color="red" @click="removeBenefit(benefit.value)" title="Remove Benefit">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <tr v-if="checkAccess(['motorQuoteShowBen']) && inclGst">
            <td colspan="4" class="inclGstAlert">
              <v-alert :value="true" type="info">
                Benefit(s) premium is inclusive of GST
              </v-alert>
            </td>
          </tr>
          <template v-if="showSummaryDetail">
            <tr class="summaryRow" key="premDue" v-if="checkAccess(['motorQuoteShowDisc'])">
              <td colspan="2">
                <v-layout row wrap align-center>
                  <v-flex>
                    <v-btn flat color="primary" title="Hide Details" @click="showSummaryDetail = false">
                      Hide Details
                      <v-icon right>mdi-chevron-up</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex d-flex>
                    <span class="text-xs-right">
                      Gross Premium
                    </span>
                  </v-flex>
                </v-layout>
              </td>
              <td class="text-xs-right">{{currPrefix}}{{formatDisplayNumber(premiumInfo.premDue)}}</td>
              <td></td>
            </tr>
            <tr class="summaryRow" key="premDue" v-else>
              <td colspan="4">
                <v-layout row wrap align-center>
                  <v-flex>
                    <v-btn flat color="primary" title="Hide Details" @click="showSummaryDetail = false">
                      Hide Details
                      <v-icon right>mdi-chevron-up</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </td>
            </tr>
            <tr class="summaryRow" key="discAmt" v-if="checkAccess(['motorQuoteShowDisc'])">
              <td class="text-xs-right" colspan="2">Disc Amount</td>
              <td class="text-xs-right">({{formatDisplayNumber(premiumInfo.discPct)}}%) {{currPrefix}}{{formatDisplayNumber(premiumInfo.discAmt)}}</td>
              <td>
                <v-icon v-if="canAdjustDisc" color="primary" @click="openShowAdjust">mdi-pencil</v-icon>
              </td>
            </tr>
            <tr class="summaryRow" key="netPremDue" v-if="checkAccess(['motorQuoteShowDisc'])">
              <td class="text-xs-right" colspan="2">
                Net Premium
              </td>
              <td class="text-xs-right">{{currPrefix}}{{formatDisplayNumber(premiumInfo.netPremDue)}}</td>
              <td></td>
            </tr>
            <tr class="summaryRow" key="gstAmt" v-if="checkAccess(['motorQuoteShowDisc'])">
              <td class="text-xs-right" colspan="2">GST Amount</td>
              <td class="text-xs-right">({{formatDisplayNumber(premiumInfo.gstRate)}}%) {{currPrefix}}{{formatDisplayNumber(premiumInfo.gstAmt)}}</td>
              <td></td>
            </tr>
            <tr class="summaryRow" key="premiumPayable">
              <td class="text-xs-right text-label" colspan="2">Premium Payable</td>
              <td class="text-xs-right strong-value">{{currPrefix}}{{formatDisplayNumber(premiumInfo.premiumPayable)}}</td>
              <td></td>
            </tr>
            <tr class="breakRow" key="breakRow" v-if="checkAccess(['motorQuoteShowComm'])">
              <td colspan="4"></td>
            </tr>
            <tr class="summaryRow" key="commGN" v-if="checkAccess(['motorQuoteShowComm'])">
              <td class="text-xs-right" colspan="2">Commission G/N</td>
              <td class="text-xs-right">{{premiumInfo.commGN}}</td>
              <td></td>
            </tr>
            <tr class="summaryRow" key="commAmt" v-if="checkAccess(['motorQuoteShowComm'])">
              <td class="text-xs-right" colspan="2">Commission Amount</td>
              <td class="text-xs-right">({{formatDisplayNumber(premiumInfo.commRate)}}%) {{currPrefix}}{{formatDisplayNumber(premiumInfo.commAmt)}}</td>
              <td></td>
            </tr>
          </template>
          <template v-else>
            <tr class="summaryRow" key="premiumPayable2">
              <td colspan="2">
                <v-layout row wrap align-center>
                  <v-flex>
                    <v-btn flat color="primary" title="Show Details" @click="showSummaryDetail = true">
                      Details
                      <v-icon right>mdi-chevron-down</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex d-flex>
                    <span class="text-label text-xs-right">Premium Payable</span>
                  </v-flex>
                </v-layout>
              </td>
              <td class="text-xs-right strong-value">{{currPrefix}}{{formatDisplayNumber(premiumInfo.premiumPayable)}}</td>
              <td></td>
            </tr>
          </template>
        </tbody>
      </table>
      <loader v-else :height="300" :init="doCalculate" loadText="Calculating Premium. Please wait." errorText="Failed to Calculate Premium" :loading="premiumInfo.init === 0" :errorMsgs="premiumInfo.initErr"></loader>
    </v-card>
    <v-dialog v-model="showAdjust" max-width="600px" lazy>
      <v-card>
        <v-card-title>
          <span class="headline">Discount Adjustment</span>
          <v-spacer></v-spacer>
          <v-btn flat icon @click="showAdjust = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div>
            <v-layout row wrap>
              <v-flex xs2 class="pa-2">
                <span>Min: </span><br />
                <span class="font-weight-bold">{{formatDisplayNumber(minAdj)}}</span>
              </v-flex>
              <v-flex xs8>
                <v-text-field box v-num-mask v-model="adjDiscount" label="Discount %" type="tel" :error-messages="errors.collect('adjDiscount')" data-vv-name="adjDiscount" data-vv-as="Discount %" v-validate="{ required: true, mask_decimal:2, mask_min_value: minAdj, mask_max_value: maxAdj }" v-if="showAdjust"></v-text-field>
              </v-flex>
              <v-flex xs2 class="pa-2">
                <span>Max: </span><br />
                <span class="font-weight-bold">{{formatDisplayNumber(maxAdj)}}</span>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat="flat" @click.native="showAdjust = false">Cancel</v-btn>
          <v-btn color="primary" flat="flat" @click.native="doAdjustDisc">Adjust</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageMixin from '@/mixins/message'
import { QUOTE_MOTOR_ADDBEN, QUOTE_MOTOR_REMOVEBEN, AGENCY_QUOTATION_DISCADJ } from '@/store/types'
import { formatDisplayNumber } from '@/utils/number'

export default {
  data() {
    return {
      labels: {
        premium: 'Premium Summary'
      },
      showSummaryDetail: false,
      addBenefit: null,
      showAdjust: false,
      adjDiscount: undefined
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    premiumInfo() {
      return this.$store.state.agency.quotation.commonInfo.premium
    },
    currPrefix() {
      return this.$store.state.agency.quotation.commonInfo.currPrefix
    },
    addBenefitList() {
      const addBenefitsParam = this.$store.state.agency.quotation.motorParam.addBenefits
      const addBenefitsForm = this.$store.state.agency.quotation.motorForm.addBenefits

      if (addBenefitsParam && addBenefitsParam.length > 0) {
        let result = []
        for (let benefit of addBenefitsParam) {
          // Check if its already inside addBenefitsForm
          if (addBenefitsForm && addBenefitsForm.length > 0) {
            if (!addBenefitsForm.find(a => a === benefit.value)) {
              result.push(benefit)
            }
          } else {
            result.push(benefit)
          }
        }
        return result
      }
      return []
    },
    canAdjustDisc() {
      if (!this.premiumInfo.protDisc && this.checkAccess(['motorQuoteDisc'])) {
        return true
      }
      return false
    },
    minAdj() {
      return 0
    },
    maxAdj() {
      if (this.premiumInfo.commGN === 'G') {
        return this.premiumInfo.commRateMax
      }
      return 100
    },
    inclGst() {
      if (this.premiumInfo.inclGst) {
        return true
      }
      return false
    }
  },
  methods: {
    doCalculate() {
      this.$store.dispatch('motorQuoteCalculate')
    },
    formatDisplayNumber(num) {
      return formatDisplayNumber(num)
    },
    doAddBenefit() {
      if (this.addBenefit) {
        this.$store.commit(QUOTE_MOTOR_ADDBEN, this.addBenefit)
        this.doCalculate()
        this.addBenefit = null
      }
    },
    removeBenefit(benefit) {
      this.$store.commit(QUOTE_MOTOR_REMOVEBEN, benefit)
      this.doCalculate()
    },
    isAddableBenefit(benefit) {
      const addBenefitsParam = this.$store.state.agency.quotation.motorParam.addBenefits
      if (addBenefitsParam && addBenefitsParam.length > 0) {
        if (addBenefitsParam.find(a => a.value === benefit)) {
          return true
        }
      }
      return false
    },
    openShowAdjust() {
      // Assign latest disc % to local state instead of adjDiscount
      // Reason - discount adjustment control is done during calculation, any error will rollback to default (no adjustment)
      // therefore adjDiscount in vuex might not always be accurate
      this.adjDiscount = this.premiumInfo.discPct
      this.showAdjust = true
    },
    doAdjustDisc() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(AGENCY_QUOTATION_DISCADJ, this.adjDiscount)
          this.showAdjust = false
          // Do a recalculate
          this.doCalculate()
        }
      })
    }
  },
  mounted() {
    this.doCalculate()
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">
.summaryRow {
  background: #eee;
  .text-label {
    font-weight: 600;
  }
  .strong-value {
    font-weight: 600;
  }
}
.breakRow {
  &:hover {
    background: inherit !important;
  }
  td {
    height: 15px !important;
  }
}
.inclGstAlert {
  .v-alert {
    margin: 0 !important;
  }
}
td.inclGstAlert {
  padding: 0 !important;
}
</style>
